module.exports = __webpack_public_path__ + "static/media/educimg.a5f4d064.JPG";